import { ReactNode, FC } from 'react';
import styles from './Wrapper.module.scss';
import classNames from 'classnames';

type TWrapper = {
  className?: string | null;
  children: ReactNode;
};

const Wrapper: FC<TWrapper> = ({ children, className }) => {
  return <div className={classNames(styles.wrapper, className)}>{children}</div>;
};

export default Wrapper;
